import { NetIncomeType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredString } from '@/utils/zodUtils';

export const NetIncomeDetailsFormSchema = (t: GetTextIdTranslationType) =>
  z.object({
    annualNetIncome: requiredString(t),
    monthlyNetIncome: requiredString(t),
    netIncomeType: requiredEnum(NetIncomeType, t),
  });

export type NetIncomeDetailsFormType = z.infer<ReturnType<typeof NetIncomeDetailsFormSchema>>;
